export default "__VITE_ASSET__Bjgk4UMg__"